/* eslint-disable @typescript-eslint/no-explicit-any */
import type { JSX } from "solid-js";
import { createStore } from "solid-js/store";

interface RouterState {
  history: string[];
  currentRoute: string | null;
  list: Array<{
    path: string;
    Module: () => JSX.Element;
  }>;
  modal: {
    current: any | null;
    props: Record<string, any>;
    params: Record<string, any>;
  };
  currentFullPath: string | null;
  loginBlackList: string[];
}

export const [routerStore, setRouterStore] = createStore<RouterState>({
  history: [],
  currentRoute: null,
  list: [],
  modal: {
    current: null,
    props: {},
    params: {},
  },
  currentFullPath: null,
  loginBlackList: ["login", "register", "reset"],
});

// 工具函数：打开带参数的模态框
export const openModal = (
  modalType: string,
  params?: Record<string, unknown>,
) => {
  setRouterStore("currentRoute", modalType);
  if (params) {
    setRouterStore("modal", "params", params);
  }
};

// 工具函数：关闭模态框
export const closeModal = () => {
  setRouterStore("currentRoute", null);
  setRouterStore("modal", "params", {});
};
